import { ShopifyAuth } from "../models/ShopifyAuth";

// Centralize Shopify auth-param parsing so embedded login can be triggered
// consistently from any route, not only the dedicated /login page.
export function getShopifyAuthFromSearch(search: string): ShopifyAuth {
    const searchParams = new URLSearchParams(search);

    return {
        entire_raw_params: searchParams.toString(),
        code: searchParams.get("code") ?? "",
        embedded: searchParams.get("embedded") ?? "",
        hmac: searchParams.get("hmac") ?? "",
        host: searchParams.get("host") ?? "",
        id_token: searchParams.get("id_token") ?? "",
        link_source: searchParams.get("link_source") ?? "",
        locale: searchParams.get("locale") ?? "",
        session: searchParams.get("session") ?? "",
        shop: searchParams.get("shop") ?? "",
        state: searchParams.get("state") ?? "",
        timeStamp: searchParams.get("timestamp") ?? "",
    };
}

export function hasShopifyAuthParams(search: string): boolean {
    const authParams = getShopifyAuthFromSearch(search);
    return Boolean(
        (authParams.shop && authParams.code && authParams.state) ||
        (authParams.shop && authParams.embedded && authParams.id_token) ||
        (authParams.shop && (authParams.embedded || authParams.host))
    );
}

const shopifyAuthSearchParams = [
    "code",
    "embedded",
    "hmac",
    "host",
    "id_token",
    "link_source",
    "locale",
    "session",
    "shop",
    "state",
    "timestamp",
];

export function stripShopifyAuthParams(search: string): string {
    const searchParams = new URLSearchParams(search);
    shopifyAuthSearchParams.forEach((param) => searchParams.delete(param));

    const nextSearch = searchParams.toString();
    return nextSearch ? `?${nextSearch}` : "";
}
